import { useTranslation } from 'react-i18next';

const ClientFilters = ({ filters, handleFilterChange, cities, hasActiveFilters, clearFilters }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';

    return (
        <div className="mb-6 bg-bg-card border border-gold/20 backdrop-blur-sm shadow-xl rounded-2xl p-6">
            <h3 className={`text-lg font-bold text-gold mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                {t('filterTours')}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
                <div className="lg:col-span-1">
                    <label className="block text-sm font-medium text-textMuted mb-1">{t('propertyId')}</label>
                    <input
                        type="text"
                        name="property_id"
                        className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        placeholder={t('propertyId')}
                        value={filters.property_id}
                        onChange={handleFilterChange}
                    />
                </div>
                <div className="lg:col-span-1">
                    <label className="block text-sm font-medium text-textMuted mb-1">{t('city')}</label>
                    <select
                        name="city"
                        className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={filters.city}
                        onChange={handleFilterChange}
                    >
                        <option value="">{t('allCities')}</option>
                        {(cities || []).map(city => (
                            <option key={city.en} value={city.en}>
                                {i18n.language === 'ar' ? city.ar : (i18n.language === 'es' && city.es ? city.es : city.en)}
                            </option>
                        ))}
                    </select>
                </div>
                {filters.city && (
                    <div className="lg:col-span-1">
                        <label className="block text-sm font-medium text-textMuted mb-1">{t('area')}</label>
                        {cities?.find(c => (typeof c === 'string' ? c : c.en) === filters.city)?.subareas?.length > 0 ? (
                            <select
                                name="area"
                                className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                                value={filters.area}
                                onChange={handleFilterChange}
                            >
                                <option value="">{t('allAreas') || 'All Areas'}</option>
                                {cities.find(c => (typeof c === 'string' ? c : c.en) === filters.city).subareas.map((sub, index) => {
                                    const subValue = typeof sub === 'string' ? sub : sub.en;
                                    return (
                                        <option key={index} value={subValue}>
                                            {typeof sub === 'string' ? sub : (i18n.language === 'ar' ? sub.ar : (i18n.language === 'es' && sub.es ? sub.es : sub.en))}
                                        </option>
                                    );
                                })}
                            </select>
                        ) : (
                            <input
                                type="text"
                                name="area"
                                className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                                placeholder={t('area')}
                                value={filters.area}
                                onChange={handleFilterChange}
                            />
                        )}
                    </div>
                )}
                <div className="lg:col-span-1">
                    <label className="block text-sm font-medium text-textMuted mb-1">{t('rooms')}</label>
                    <input
                        type="number"
                        name="rooms"
                        className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        placeholder={t('rooms')}
                        value={filters.rooms}
                        onChange={handleFilterChange}
                        min="0"
                    />
                </div>
                <div className="lg:col-span-1">
                    <label className="block text-sm font-medium text-textMuted mb-1">{t('size')}</label>
                    <input
                        type="number"
                        name="size"
                        className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        placeholder={t('size')}
                        value={filters.size}
                        onChange={handleFilterChange}
                    />
                </div>
                <div className="lg:col-span-1">
                    <label className="block text-sm font-medium text-textMuted mb-1">{t('floor')}</label>
                    <input
                        type="number"
                        name="floor"
                        className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        placeholder={t('floor')}
                        value={filters.floor}
                        onChange={handleFilterChange}
                    />
                </div>
                <div className="lg:col-span-1">
                    <label className="block text-sm font-medium text-textMuted mb-1">{t('filterByStatus')}</label>
                    <select
                        name="status"
                        className="bg-bg-card/50 border border-gold/20 text-text rounded px-3 py-2 w-full focus:ring-gold focus:border-gold placeholder-textMuted/50"
                        value={filters.status}
                        onChange={handleFilterChange}
                    >
                        <option value="">{t('allStatuses')}</option>
                        <option value="draft">{t('statusDraft')}</option>
                        <option value="active">{t('statusActive')}</option>
                        <option value="reserved">{t('statusReserved')}</option>
                        <option value="sold">{t('statusSold')}</option>
                    </select>
                </div>
                <div className="lg:col-span-1 flex items-end">
                    <label className="flex items-center space-x-2 cursor-pointer mb-2">
                        <input
                            type="checkbox"
                            name="has_tour"
                            checked={filters.has_tour}
                            onChange={handleFilterChange}
                            className="h-4 w-4 text-gold border-gold/30 rounded focus:ring-gold bg-bg-card"
                        />
                        <span className="text-sm font-medium text-textMuted">{t('only3DTours')}</span>
                    </label>
                </div>
            </div>
            {hasActiveFilters && (
                <div className="mt-4 flex items-center justify-between">
                    <p className="text-sm text-textMuted">{t('filtersActive')}</p>
                    <button
                        onClick={clearFilters}
                        className="text-sm text-gold hover:opacity-80 font-medium transition-opacity"
                    >
                        {t('clearFilters')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ClientFilters;
